import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/lib/store'
import router from '@/plugins/router'
import noty from '@/plugins/noty'

const errorNotification = ({ message }) => {
  return noty({
    type: 'error',
    timeout: 10000,
    text: message
  })()
}

axios.interceptors.request.use(config => {
  const token = store.get('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  response => response,
  error => {
    if (axios.isCancel(error)) {
      console.info('Request cancelled')
      return Promise.reject(error)
    }

    if (error.response) {
      const { status, data } = error.response

      if ([401, 403].includes(status)) {
        errorNotification({ message: data.error.message }).show()

        if (status === 401) {
          store.truncate()
          router.push('/login')
        }
      }
    }

    return Promise.reject(error)
  }
)

Vue.use(VueAxios, axios)



// WEBPACK FOOTER //
// ./src/plugins/axios.js